import { memo } from 'react';
import './styles.scss';

/**
 * Renders a full-size loader with an animated pair of bubbles and an optional percentage label.
 *
 * @param {object} props - Component props.
 * @param {string} props.backgroundColor - CSS color of the loader background.
 * @param {string} props.loaderColor - CSS color of the bubbles and the percentage text.
 * @param {boolean} [props.isOverlay] - Whether the loader covers the page as an overlay; defaults to true.
 * @param {number} [props.loadingProgression] - Load progress from 0 to 1, shown as a percentage when above 0; defaults to 0.
 * @returns {JSX.Element} - The loader markup.
 */
const BubbleLoader = ({
    backgroundColor,
    loaderColor,
    isOverlay = true,
    loadingProgression = 0,
}) => {
    const loadingPercentage = Math.round(loadingProgression * 100);

    return (
        <div
            className={`bubleloader-container${isOverlay ? ' overlay' : ''}`}
            style={{ backgroundColor: backgroundColor }}>
            {loadingProgression && loadingProgression !== 0 ? (
                <p className={'loading-percentage'} style={{ color: loaderColor }}>
                    {loadingPercentage}%
                </p>
            ) : null}
            <div className={`spinner${isOverlay ? ' overlay' : ''}`}>
                <div className='bubble-1' style={{ backgroundColor: loaderColor }} />
                <div className='bubble-2' style={{ backgroundColor: loaderColor }} />
            </div>
        </div>
    );
};

export default memo(BubbleLoader);
